<template>
  <div ref="SunburstChart" style="width: 100%; height: 100%"></div>
</template>

<script>
import * as echarts from "echarts";
import { generateSunburstChartTooltip } from "@/utils/tooltip";

export default {
  name: "SunburstChart",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    data: {
      handler() {
        this.chart && this.chart.dispose();
        this.init();
      },
      deep: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      let option = {
        tooltip: {
          show: true,
          backgroundColor: "transplant",
          borderColor: "transplant",
          borderWidth: 0,
          padding: 0,
          formatter: function (params) {
            if (!params.name) {
              return "";
            }
            return generateSunburstChartTooltip({
              name: params.name,
              value: params.data?.textValue || 0,
              primaryColor: params.color,
              borderColor: params.color,
            });
          },
        },
        series: {
          type: "sunburst",
          data: this.data,
          radius: ["0%", "100%"],
          label: {
            color: "#fff",
            overflow: "truncate",
          },
          labelLayout: {
            hideOverlap: true,
          },
          levels: [
            {},
            {
              r0: "5%",
              r: "30%",
            },
            {
              r0: "30%",
              r: "70%",
            },
            {
              r0: "70%",
              r: "85%",
            },
            {
              r0: "85%",
              r: "100%",
            },
          ],
        },
        color: ["#61deab", "#6a98ff"],
      };
      this.chart = echarts.init(
        this.$refs.SunburstChart,
        {},
        {
          renderer: "svg",
        }
      );
      this.chart.setOption(option);
      this.chart.on("finished", () => {
        this.$emit("finished");
        this.chart.off("finished");
      });
    },
  },
  beforeDestroy() {
    // 在组件销毁前，销毁 ECharts 实例
    this.chart && this.chart.dispose();
  },
};
</script>

<style lang="scss" scoped></style>
